import z from 'zod';

export const firestoreTimestampAdminSchema = z.custom<{
  _seconds: number;
  _nanoseconds: number;
}>((value) => {
  if (typeof value !== 'object' || value === null) {
    return false;
  }

  const {_seconds, _nanoseconds} = value as {
    _seconds?: unknown;
    _nanoseconds?: unknown;
  };

  return typeof _seconds === 'number' && typeof _nanoseconds === 'number';
});

export type FirestoreTimestampAdmin = z.infer<typeof firestoreTimestampAdminSchema>;
